import { useNavigate } from 'react-router-dom';
import { PageContainer } from '@/components';
import { SelfList } from './Self';
import { useAppContext, useSelfContext } from '@/context';
import { useSingleSelfRedirect } from '@/hooks';

export function SelfPage() {
  const navigate = useNavigate();
  const { mode } = useAppContext();
  const { redirectToReserve } = useSelfContext();

  useSingleSelfRedirect();

  return (
    <PageContainer title="سلف های مجاز">
      <SelfList onSelect={() => redirectToReserve({ mode, navigate })} />
    </PageContainer>
  );
};

export default SelfPage;
